import {
  effect,
  Injectable,
  InputSignal,
  NgZone,
  Signal,
  signal,
  untracked,
} from '@angular/core';

export interface FlutterMessage {
  type: string;
  data: any;
}

@Injectable({ providedIn: 'root' })
export class FlutterBridgeService {
  // The "Source of Truth" for the latest message from Flutter
  private messageSignal = signal<FlutterMessage | null>(null);
  public latestMessage = this.messageSignal.asReadonly();

  constructor(private zone: NgZone) {
    if ((window as any).flutter_inappwebview) {
      (window as any).receiveMessageFromFlutter = (jsonString: string) => {
        this.zone.run(() => {
          try {
            const payload = JSON.parse(jsonString);
            // Setting the signal triggers any active effects
            this.messageSignal.set({ type: payload.type, data: payload });
          } catch (e) {
            console.error('Flutter Parse Error', e);
          }
        });
      };
    }
  }

  async call(handler: string, payload: any = {}): Promise<any> {
    return await (window as any).flutter_inappwebview.callHandler(
      handler,
      payload,
    );
  }

  clearMessage() {
    this.messageSignal.set(null);
  }
}

/**
 * A generic reusable handler for Bridge events.
 * @param T The specific message type string literal.
 */
export function createBridgeHandler<T extends string>(
  bridge: FlutterBridgeService | undefined,
  targetType: T,
  question: InputSignal<any>,
  onSuccess: (data: any) => void, // You can replace 'any' with a specific MessageData interface
) {
  return effect(() => {
    const msg = bridge?.latestMessage();
    const currentId = question().id;

    // Now 'targetType' is passed as an argument
    if (msg?.type === targetType && msg.data?.question === currentId) {
      untracked(() => {
        onSuccess(msg.data);
        bridge?.clearMessage();
      });
    }
  });
}
